import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb, mv, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import ResponsiveCard from "../../../atoms/responsive_card/ResponsiveCard";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {vendorViewExternalSiteClick} from "../../../tracking/algolytics_hits/external_site_click";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
    hasActiveOffers: boolean;
}

export const VendorDetailContact = (props: IProps) => {
    const {vendor, hasActiveOffers} = props;
    const vendorTrackedSite = {
        id: vendor.id,
        name: vendor.name,
        slug: vendor.slug
    };

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.CONTACT_VENDOR_PAGE,
        vendorName: vendor.name,
        offerName: ""
    };

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4)]}>
                Kontakt
            </Text>

            <ResponsiveCard>
                <ResponsiveCard.BodySimple css={cardBodyStyle}>
                    {vendor.logo?.v_log_120x90 && (
                        <Image src={vendor.logo.v_log_120x90} alt={`${vendor.name} logo`} width="120px" height="90px" css={[mb(3)]} />
                    )}

                    <Text as="div" variant="headline_5" css={[mb(1)]}>
                        {vendor.name}
                    </Text>

                    {vendor.headquarters && (
                        <Text as="address" variant="info_txt_3" css={vendorAddress}>
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}

                    {vendor.website && (
                        <a
                            css={vendorLinkStyle}
                            href={
                                vendor.configuration.include_utm
                                    ? appendQueryString(vendor.website, {
                                          utm_campaign: "prezentacja",
                                          utm_medium: "referral",
                                          utm_source: "rynekpierwotny"
                                      })
                                    : vendor.website
                            }
                            target="_blank"
                            rel="nofollow"
                            data-gtm-click="Odwiedź stronę dewelopera"
                            onClick={() => vendorViewExternalSiteClick(vendorTrackedSite)}
                        >
                            Strona internetowa dewelopera
                        </a>
                    )}

                    {hasActiveOffers && (
                        <ApplicationModalButton
                            vendorId={vendor.id}
                            offerId={null}
                            propertyId={null}
                            source={ApplicationSource.Vendor}
                            sourceSection={ApplicationSourceSection.MODAL}
                            hideQuestions
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="medium" css={inquiryButtonStyle} onClick={() => openModal(gtmData)}>
                                    {InquiryButtonTypeName.VENDOR}
                                </Button>
                            )}
                        />
                    )}
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </>
    );
};

const cardBodyStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${p(3)};
`;

const vendorAddress = (theme: Theme) => css`
    color: ${theme.colors.gray["600"]};
    ${mb(3)};
`;

const vendorLinkStyle = (theme: Theme) => css`
    text-decoration: underline;
    ${mb(3)};

    &:hover {
        color: ${theme.colors.secondary};
    }
`;

const inquiryButtonStyle = css`
    ${mv(3)};
    width: 100%;
    max-width: 30rem;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {mb, mv, p} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import ResponsiveCard from "../../../atoms/responsive_card/ResponsiveCard";
import {GTMEventApplicationSourceSection} from "../../../lead/types/GTMEvenApplicationSourceSection";
import {vendorViewExternalSiteClick} from "../../../tracking/algolytics_hits/external_site_click";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IVendorDetail} from "../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
    hasActiveOffers: boolean;
}

export const VendorDetailContact = (props: IProps) => {
    const {vendor, hasActiveOffers} = props;
    const vendorTrackedSite = {
        id: vendor.id,
        name: vendor.name,
        slug: vendor.slug
    };

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.CONTACT_VENDOR_PAGE,
        vendorName: vendor.name,
        offerName: ""
    };

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4)]}>
                Kontakt
            </Text>

            <ResponsiveCard>
                <ResponsiveCard.BodySimple css={cardBodyStyle}>
                    {vendor.logo?.v_log_120x90 && (
                        <Image src={vendor.logo.v_log_120x90} alt={`${vendor.name} logo`} width="120px" height="90px" css={[mb(3)]} />
                    )}

                    <Text as="div" variant="headline_5" css={[mb(1)]}>
                        {vendor.name}
                    </Text>

                    {vendor.headquarters && (
                        <Text as="address" variant="info_txt_3" css={vendorAddress}>
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}

                    {vendor.website && (
                        <a
                            css={vendorLinkStyle}
                            href={
                                vendor.configuration.include_utm
                                    ? appendQueryString(vendor.website, {
                                          utm_campaign: "prezentacja",
                                          utm_medium: "referral",
                                          utm_source: "rynekpierwotny"
                                      })
                                    : vendor.website
                            }
                            target="_blank"
                            rel="nofollow"
                            data-gtm-click="Odwiedź stronę dewelopera"
                            onClick={() => vendorViewExternalSiteClick(vendorTrackedSite)}
                        >
                            Strona internetowa dewelopera
                        </a>
                    )}

                    {hasActiveOffers && (
                        <ApplicationModalButton
                            vendorId={vendor.id}
                            offerId={null}
                            propertyId={null}
                            source={ApplicationSource.Vendor}
                            sourceSection={ApplicationSourceSection.MODAL}
                            hideQuestions
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="medium" css={inquiryButtonStyle} onClick={() => openModal(gtmData)}>
                                    {InquiryButtonTypeName.VENDOR}
                                </Button>
                            )}
                        />
                    )}
                </ResponsiveCard.BodySimple>
            </ResponsiveCard>
        </>
    );
};

const cardBodyStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${p(3)};
`;

const vendorAddress = (theme: Theme) => css`
    color: ${theme.colors.gray["600"]};
    ${mb(3)};
`;

const vendorLinkStyle = (theme: Theme) => css`
    text-decoration: underline;
    ${mb(3)};

    &:hover {
        color: ${theme.colors.secondary};
    }
`;

const inquiryButtonStyle = css`
    ${mv(3)};
    width: 100%;
    max-width: 30rem;
`;
